export const getNonce = (): string =>
  document
    .querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')
    ?.getAttribute('content') ?? '';
